import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '@/assets/home/game_arrow_white.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "table_container" }
const _hoisted_4 = {
  key: 0,
  style: {"color":"#0484ff"}
}
const _hoisted_5 = {
  key: 1,
  style: {"color":"#36d836"}
}
const _hoisted_6 = {
  key: 2,
  style: {"color":"#ff0000"}
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 1,
  class: "no_more"
}

import { computed, ref } from 'vue';
import CustomHeader from '../../components/common/customHeader.vue';
import NoData from '../../components/common/noData.vue';
import { ChestUserData, TAB_LIST } from '@/view/activeChest/supportScript';


export default /*@__PURE__*/_defineComponent({
  __name: 'chestUserDetails',
  props: {
    dataSet: {}
  },
  emits: ['onClickTab', 'getNextPageMsgList'],
  setup(__props: any, { emit: __emit }) {

const tabList = computed(() => TAB_LIST)
const active = ref(0);

const props = __props
const emits = __emit

const onClickTab = (active: any) => {
    emits('onClickTab', active)
}
const getNextPageMsgList = () => {
    emits('getNextPageMsgList')
}


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('bonus.playersInvited')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_tabs, {
        active: active.value,
        "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
        sticky: "",
        ellipsis: false,
        onClickTab: onClickTab
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item, index) => {
            return (_openBlock(), _createBlock(_component_van_tab, {
              key: index,
              title: _ctx.$t(item.name),
              name: index
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_van_row, { class: "tabel_head" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_van_col, {
                            span: "6",
                            class: "tabel_alignment"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('bonus.player')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_van_col, {
                            span: "6",
                            class: "tabel_alignment"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('bonus.invitationDate')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_van_col, {
                            span: "6",
                            class: "tabel_alignment"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('dayList.giftAmount')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_van_col, {
                            span: "6",
                            class: "tabel_alignment"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('bonus.status')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.playersList, (item, index) => {
                        return (_openBlock(), _createBlock(_component_van_row, {
                          class: "tabel_row",
                          key: index,
                          style: _normalizeStyle({
                                backgroundColor: index % 2 === 1 ? '#ffffff0a' : '#1a1d22'
                            })
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_van_col, {
                              span: "6",
                              class: "tabel_alignment"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.uid), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_van_col, {
                              span: "6",
                              class: "tabel_alignment"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.createTime), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_van_col, {
                              span: "6",
                              class: "tabel_alignment"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.rewardAmount), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_van_col, {
                              span: "6",
                              class: "tabel_alignment"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString() + " ", 1),
                                (item.claimStatus == 0)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t('activityStatus.pending')), 1))
                                  : (item.claimStatus == 1)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t('activityStatus.active')), 1))
                                    : (item.claimStatus == 2)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t('activityStatus.inactive')), 1))
                                      : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["style"]))
                      }), 128))
                    ])
                  ]),
                  (_ctx.dataSet.playersList.length <= 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(NoData)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (_ctx.dataSet.total > _ctx.dataSet.pageSize * _ctx.dataSet.pageNum)
                          ? (_openBlock(), _createBlock(_component_van_row, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_van_col, {
                                  span: "24",
                                  class: "arrowDown"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", {
                                      src: _imports_0,
                                      alt: "",
                                      onClick: getNextPageMsgList
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('message.noMore')), 1))
                      ]))
                ])
              ]),
              _: 2
            }, 1032, ["title", "name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["active"])
    ])
  ], 64))
}
}

})